import React, { useState, useRef, useEffect, useCallback } from "react";
import { Avatar, Button, Tooltip, message } from "antd";
import Modal from "react-modal";
import "./chat.css";
import bot from "../../assets/bot.png";
import ReactMarkdown from "react-markdown";
import profilePic from "../../assets/profile_pic.png";
import AAPALOGO from "../../assets/logo3.png";

import {
  SendOutlined,
  PaperClipOutlined,
  MoreOutlined,
  CloseOutlined,
  LogoutOutlined,
  MinusOutlined,
  MessageOutlined,
  FormOutlined,
  InboxOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

import axios from "axios";
// import useChatSocket from '../../hooks/useBotListener.js'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import Carousel from "../carousel/Carousel";
import { store } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsBotTyping,
  setIsUserTyping,
  setMessages,
} from "../../redux/reducer/chatReducer";
import { BE_HOST } from "../../config/config";

const Chat = ({ open, setOpen }) => {
  const [inputValue, setInputValue] = useState("");
  const chatContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);
  const messagesContainerRef = useRef(null);
  const prevMessageCountRef = useRef(0);
  const [lang, setLang] = useState("en");
  const [isImageAttach, setIsAttachImage] = useState(false);
  const [choiceSelections, setChoiceSelections] = React.useState({});
  const [attchedImage, setAttachedImage] = useState("");
  const [chatVisible, setChatVisible] = useState(false);
  const dispatch = useDispatch();
  const isBotTyping = useSelector((state) => {
    return state.chats?.isBotTyping;
  });
  const isUserTyping = useSelector((state) => {
    return state.chats?.isUserTyping;
  });
  const UserId = JSON.parse(localStorage.getItem("VisitorID"));
  const RoomId = JSON.parse(localStorage.getItem("RoomId"));
  const Authtoken = JSON.parse(localStorage.getItem("AuthToken"));
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const SelectedPharmacy = useSelector((state) => {
    return state.pharmacyData?.pharmacyData;
  });
  const pharmacylabel = useSelector((state) => {
    return state.pharmacyData?.pharmacyLabel;
  });
  // const messages = useSelector((state) => {
  //   return state.chats?.messages;
  // });

  const [messages, setMessages] = useState([]);

  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleChatLogin = async () => {
    const data = {
      email: userInfo?.user?.email,
      username: userInfo?.user?.first_name,
      password: "abc@2025",
      name:pharmacylabel,
      accountname: pharmacylabel,
      accountnumber: JSON.stringify(SelectedPharmacy?.at(-1)),
      // email:"abc@gmail.com",
      
      // phone: userInfo?.user?.phone,
      // email:"abc@axy.ae",
      //       username: "Test User",
      //       password : "pwd@2025",
      //       name : "Test",
      //       accountnumber: "74685",
      //       accountname: "NEW MO-TOWN PHCY"
    };
    try {
      const response = await axios.post(`${BE_HOST}/chat/auth/userAuth`, data, {
        headers: { "Content-Type": "application/json" },
      });
      localStorage.setItem("AuthToken", JSON.stringify(response?.data?.token));
      localStorage.setItem("RoomId", JSON.stringify(response?.data?.room?._id));
      localStorage.setItem(
        "VisitorID",
        JSON.stringify(response?.data?.visitor?._id),
      );
      setChatVisible(true);
      getAllMessage(response?.data);
    } catch (error) {
      console.log(error, "errorrr");
    } finally {
    }
  };

  const getAllMessage = async (data) => {
    try {
      const response = await axios.get(
        `${BE_HOST}/chat/room/${data?.room?._id || RoomId}/history`,
        {
          params: {
            token: data?.token || Authtoken,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      store.dispatch(setMessages(response?.data?.messages));
    } catch (error) {
      console.error(
        "Error fetching messages:",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      store.dispatch(setIsBotTyping(false));
    }
  };

  // useEffect(() => {
  //   if (open) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }

  //   return () => {
  //     document.body.style.overflow = "auto"; // Restore on unmount
  //   };
  // }, [open]);
  const handleSend = (item) => {
    if (!inputValue?.trim()) return;
    dispatch(setIsUserTyping(true));
    const messageToSend = inputValue || item?.label;
    setInputValue("");
    getChat(messageToSend);
    setTimeout(scrollToBottom, 100);
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const atBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 50;
      setIsAtBottom(atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (
      (autoScroll && messages?.length > prevMessageCountRef.current) ||
      isBotTyping
    ) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevMessageCountRef.current = messages.length;
  }, [messages, autoScroll, isBotTyping]);

  const getChat = async (inp) => {
    const payload = {
      token: Authtoken,
      text: inp,
    };
    try {
      const response = await axios.post(
        `${BE_HOST}/chat/room/${RoomId}/send-message`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      dispatch(setIsUserTyping(false));
      dispatch(setIsBotTyping(true));
      getAllMessage();
    } catch (error) {
      console.error(
        "Error fetching chat:",
        error.response?.data?.message || error.message,
      );
    } finally {
      dispatch(setIsUserTyping(false));
    }
  };

  useEffect(() => {
    if (!UserId || !Authtoken || !RoomId || open === false) return;
    const interval = setInterval(() => {
      getAllMessage();
    }, 20000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [UserId, Authtoken, RoomId, open]);

  // useChatSocket(
  //   RoomId, Authtoken
  // );

  const handleClose = () => {
    setOpen(false);
    localStorage.removeItem("AuthToken");
    localStorage.removeItem("RoomId");
    localStorage.removeItem("VisitorID");
  };
  useEffect(() => {
    if (open || chatVisible) {
      setTimeout(() => {
        messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [open, chatVisible]);

  const handleAttach = () => {
    const input = document.createElement("input");
    input.type = "file";

    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        console.log("Not a Image");
        return;
      }
      setIsAttachImage(true);
      const reader = new FileReader();
      reader.onload = () => {
        setAttachedImage({
          fileName: file.name,
          previewUrl: reader.result,
          isImage,
        });
      };
      reader.readAsDataURL(file);
    };

    input.click();
  };

  const closePreview = () => {
    setIsAttachImage(false);
  };

  // useEffect(() => {
  //   if (!RoomId || !Authtoken || !UserId) return;
  //   getAllMessage();
  // }, []);

  const formatChatDate = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (d1, d2) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDay(date, today)) return "Today";
    if (isSameDay(date, yesterday)) return "Yesterday";

    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        className="chat-modal w-[88%] md:w-[32%] outline-none"
        overlayClassName="chat-overlay"
        ariaHideApp={false}
      >
        <div className="chat-container">
          {!RoomId || !Authtoken || !UserId ? (
            <div className="max-h-[100vh] overflow-y-auto">
              <div className="flex justify-between items-center bg-[#edf4ff]">
                <div className="p-4 mb-2 bg-[#edf4ff]">
                  <h2 className="text-[16px] font-semibold text-[#003366]">
                    Customer Support
                  </h2>
                  <p className="text-sm text-gray-500">
                    We're here to help you 24/7
                  </p>
                </div>
                <div className="mr-5">
                  <MinusOutlined
                    onClick={() => setOpen(false)}
                    className="dot-icon"
                    style={{
                      cursor: "pointer",
                      color: "#003366",
                      fontSize: "20px",
                    }}
                  />
                </div>
              </div>
              <div className="px-4 py-2">
                <div
                  className="rounded-xl p-5 shadow-md flex flex-col items-center min-h-64 justify-center"
                  style={{
                    background: "#000437",
                    color: "white",
                  }}
                >
                  <div className="border border-white p-2  rounded-full mb-4 flex items-center justify-center">
                    <MessageOutlined className="text-white text-2xl" />
                  </div>

                  <h3 className="text-lg font-medium">Need Assistance?</h3>
                  <p className="text-sm mt-1 text-blue-100">
                    Connect with our compliance support team
                  </p>

                  <Button
                    type="default"
                    className="mt-4 flex items-center gap-2 font-medium px-5 py-5 rounded-lg shadow"
                    style={{
                      height: "38px",
                      borderRadius: "8px",
                      color: "#0A66C2",
                      border: "none",
                    }}
                    onClick={() => handleChatLogin()}
                  >
                    <MessageOutlined style={{ color: "#0A66C2" }} />
                    Start Live Chat
                  </Button>
                </div>

                <p
                  className="text-center text-gray-400 text-xs mt-4 absolute bottom-4"
                  style={{ marginLeft: "22%" }}
                >
                  Average response time: &lt; 2 minutes
                </p>
              </div>
            </div>
          ) : (
            <>
              <div className="chat-header">
                <div className="flex justify-between w-full">
                  <div className="w-[66%] flex justify-end">
                    <img
                      src={AAPALOGO}
                      alt="logo"
                      className="w-32 h-24 object-contain p-0 m-0"
                    />
                  </div>

                  <div>
                    <MinusOutlined
                      onClick={() => setOpen(false)}
                      className="dot-icon"
                      style={{
                        cursor: "pointer",
                        color: "#fff",
                        fontSize: "20px",
                      }}
                    />
                    <MoreOutlined
                      className="dot-icon"
                      style={{
                        cursor: "pointer",
                        color: "#fff",
                        fontSize: "20px",
                      }}
                    />
                    <LogoutOutlined
                      onClick={() => handleClose()}
                      style={{
                        cursor: "pointer",
                        color: "#fff",
                        fontSize: "20px",
                      }}
                    />
                  </div>
                </div>
              </div>
              {isImageAttach ? (
                <div className="image-preview-bar">
                  <button className="close-btn" onClick={closePreview}>
                    <CloseOutlined style={{ fontSize: 16, color: "#fff" }} />
                  </button>
                  <div className="preview-wrapper">
                    <img
                      src={attchedImage?.previewUrl}
                      alt="preview"
                      className="preview-image"
                    />
                  </div>

                  <button className="send-btn2">
                    <SendOutlined style={{ fontSize: 20, color: "#fff" }} />
                  </button>
                </div>
              ) : (
                <>
                  <div
                    ref={chatContainerRef}
                    className="chat-body chat-scroll-container"
                    style={{
                      flex: 1,
                      overflowY: "auto",
                      paddingTop: "16px",
                      display: "flex",
                      flexDirection: "column",
                      // gap: "12px",
                    }}
                  >
                    {[...messages]
                      ?.sort(
                        (a, b) =>
                          new Date(a._updatedAt) - new Date(b._updatedAt),
                      )
                      .filter((m) => m?.msg && m.msg.trim() !== "")
                      ?.map((msg, index, arr) => {
                        const isUser = msg?.u?._id === UserId;
                        const sender = isUser ? "user" : "bot";
                        const AvatarURL = isUser
                          ? profilePic
                          : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3ZQ4qq6HTCOhCqRndPnoN8825N3eEsi9tLw&s";
                        const prevMsg = arr[index - 1];
                        const prevSender =
                          prevMsg?.u?._id === UserId ? "user" : "bot";
                        const text = msg?.msg || "";
                        const time = new Date(
                          msg?._updatedAt,
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        });
                        let fullMessage = text.trim();
                        fullMessage = fullMessage.replace(/```/g, "");

                        fullMessage = fullMessage.replace(
                          /(https?:\/\/[^\s]+)/g,
                          (url) => `[${url}](${url})`,
                        );
                        fullMessage = fullMessage.replace(/<br\s*\/?>/gi, "\n");

                        const showAvatar = index === 0 || sender !== prevSender;
                        const msgKey =
                          msg?._id ||
                          msg?.id ||
                          `${msg?._updatedAt}-${(msg?.msg || "").slice(0, 20)}`;
                        const selectedIndexForThisMsg =
                          choiceSelections[msgKey];
                        const isLocked = selectedIndexForThisMsg !== undefined;
                        const currentDate = new Date(msg._updatedAt);
                        const prevMessage = arr[index - 1];
                        const prevDate = prevMessage
                          ? new Date(prevMessage._updatedAt)
                          : null;

                        const shouldShowDate =
                          index === 0 ||
                          currentDate.toDateString() !==
                            prevDate?.toDateString();
                        return (
                          <>
                            {shouldShowDate && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: "20px",
                                  gap: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    height: 1,
                                    background: "#dcdcdc",
                                  }}
                                ></div>
                                <span
                                  style={{
                                    fontSize: 12,
                                    color: "#666",
                                    background: "#f5f5f5",
                                    padding: "4px 10px",
                                    borderRadius: 20,
                                  }}
                                >
                                  {formatChatDate(msg._updatedAt)}
                                </span>

                                <div
                                  style={{
                                    flex: 1,
                                    height: 1,
                                    background: "#dcdcdc",
                                  }}
                                ></div>
                              </div>
                            )}

                            <div
                              style={{
                                background: sender == "user" ? null : null,
                                marginBottom: sender == "user" ? "5px" : "5px",
                                // paddingBottom: 10,
                                // borderRadius:20,
                                borderTopLeftRadius:
                                  index > 0 && sender !== prevSender ? 20 : 0,
                                borderTopRightRadius:
                                  index > 0 && sender !== prevSender ? 20 : 0,
                                borderBottomRightRadius:
                                  index > 0 && sender !== prevSender ? 20 : 0,
                                borderBottomLeftRadius:
                                  index > 0 && sender !== prevSender ? 20 : 0,
                                width: sender == "user" ? "100%" : "70%",
                              }}
                            >
                              {fullMessage && (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    flexDirection:
                                      sender === "user" ? "row-reverse" : "row",
                                    alignItems: "flex-start",
                                    gap: 8,
                                    marginTop:
                                      index > 0 && sender !== prevSender
                                        ? 20
                                        : 10,
                                    marginLeft: 3,
                                  }}
                                >
                                  {showAvatar ? (
                                    <Avatar
                                      src={AvatarURL}
                                      alt={sender}
                                      size={"large"}
                                    />
                                  ) : (
                                    <div style={{ width: 40 }} />
                                  )}
                                  <div
                                    style={{
                                      background:
                                        sender === "user" ? "#000437" : "#fff",
                                      padding: "8px 12px",
                                      borderTopLeftRadius: 25,
                                      borderTopRightRadius: 25,
                                      borderBottomRightRadius:
                                        sender === "user" ? 0 : 25,
                                      borderBottomLeftRadius:
                                        sender === "user" ? 25 : 0,
                                      // maxWidth: "65%",
                                      maxWidth:
                                        sender === "user" ? "65%" : "84%",
                                      // boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color:
                                          sender === "user" ? "#fff" : "#333",
                                        fontSize: 14,
                                        fontFamily: "Arial, sans-serif",
                                        direction: "ltr",
                                        textAlign: "left",
                                      }}
                                    >
                                      <ReactMarkdown
                                        children={fullMessage}
                                        remarkPlugins={[remarkGfm]}
                                        rehypePlugins={[
                                          rehypeRaw,
                                          rehypeSanitize,
                                        ]}
                                        components={{
                                          p: ({ node, ...props }) => (
                                            <p
                                              style={{
                                                margin: "8px 0",
                                                lineHeight: "1.6",
                                              }}
                                              {...props}
                                            />
                                          ),
                                          strong: ({ node, ...props }) => (
                                            <strong
                                              style={{ fontWeight: "bold" }}
                                              {...props}
                                            />
                                          ),
                                          em: ({ node, ...props }) => (
                                            <em
                                              style={{ fontStyle: "italic" }}
                                              {...props}
                                            />
                                          ),
                                          ul: ({ node, ...props }) => (
                                            <ul
                                              style={{
                                                paddingLeft: 20,
                                                margin: "8px 8px",
                                                listStyleType: "disc",
                                              }}
                                              {...props}
                                            />
                                          ),
                                          ol: ({ node, ...props }) => (
                                            <ol
                                              style={{
                                                paddingLeft: 20,
                                                margin: "8px 8px",
                                                listStyleType: "decimal",
                                              }}
                                              {...props}
                                            />
                                          ),
                                          li: ({ node, ...props }) => (
                                            <li
                                              style={{ marginBottom: 4 }}
                                              {...props}
                                            />
                                          ),
                                          a: ({ node, ...props }) => (
                                            <a
                                              style={{
                                                color:
                                                  sender === "user"
                                                    ? "#aadfff"
                                                    : "#007bff",
                                                textDecoration: "underline",
                                                wordBreak: "break-word",
                                              }}
                                              {...props}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            />
                                          ),
                                          code: ({ node, ...props }) => (
                                            <code
                                              style={{
                                                background: "#f4f4f4",
                                                padding: "2px 4px",
                                                borderRadius: 4,
                                              }}
                                              {...props}
                                            />
                                          ),
                                        }}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 10,
                                        textAlign: "right",
                                        color:
                                          sender === "user"
                                            ? "#d5dbd6"
                                            : "#888",
                                      }}
                                    >
                                      {time}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        );
                      })}
                    {isUserTyping && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          alignItems: "flex-start",
                          gap: 8,
                          marginRight: 10,
                          marginTop: 20,
                        }}
                      >
                        <Avatar src={profilePic} alt="user" size={"large"} />
                        <div
                          style={{
                            background: "#000437",
                            padding: "8px 12px",
                            borderTopLeftRadius: 25,
                            borderTopRightRadius: 25,
                            borderBottomRightRadius: 0,
                            borderBottomLeftRadius: 25,
                            maxWidth: "65%",
                            fontSize: 14,
                            fontFamily: "arial",
                            color: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                          }}
                        >
                          <div>{inputValue || "Sending..."}</div>
                        </div>
                      </div>
                    )}
                    <div ref={messagesEndRef} />
                  </div>
                  <div className="chat-input">
                    <button className="icon-btn">
                      <PaperClipOutlined style={{ fontSize: 20 }} />
                    </button>

                    <input
                      type="text"
                      placeholder={"Type your question here..."}
                      value={inputValue}
                      className="w-[40%]"
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSend();
                      }}
                      style={{
                        direction: lang === "ar" ? "rtl" : "ltr",
                        textAlign: lang === "ar" ? "right" : "left",
                      }}
                    />
                    <button className="send-btn" onClick={handleSend}>
                      <SendOutlined style={{ fontSize: 20, color: "white" }} />
                    </button>
                  </div>
                  {/* )} */}
                </>
              )}
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Chat;